import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Box } from '@mui/material';

// Fix for default marker icon issue with webpack
// Using images from public folder
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: '/marker-icon-2x.png',
  iconUrl: '/marker-icon.png',
  shadowUrl: '/marker-shadow.png',
});

interface LocationMapProps {
  latitude: number;
  longitude: number;
  locationName?: string;
  height?: number | string;
  zoom?: number;
  showPopup?: boolean;
}

const LocationMap: React.FC<LocationMapProps> = ({
  latitude,
  longitude,
  locationName,
  height = 300,
  zoom = 15,
  showPopup = true,
}) => {
  const position: L.LatLngExpression = [latitude, longitude];

  return (
    <Box
      sx={{
        height,
        width: '100%',
        borderRadius: 2,
        overflow: 'hidden',
        minHeight: { xs: '180px', sm: '200px' },
        maxHeight: { xs: '250px', sm: '300px' },
        '& .leaflet-container': {
          height: '100%',
          width: '100%',
          borderRadius: 2,
        },
        '& .leaflet-popup-content-wrapper': {
          borderRadius: '8px',
        },
        '& .leaflet-control-zoom': {
          border: 'none',
          borderRadius: '8px',
          overflow: 'hidden',
          '@media (max-width: 600px)': {
            transform: 'scale(0.8)',
          }
        },
        '& .leaflet-control-attribution': {
          fontSize: { xs: '0.6rem', sm: '0.7rem' },
        }
      }}
    >
      <MapContainer
        center={position}
        zoom={zoom}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
        dragging={true}
        touchZoom={true}
        zoomControl={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          {showPopup && locationName && (
            <Popup>
              <strong>{locationName}</strong>
              <br />
              {latitude.toFixed(6)}, {longitude.toFixed(6)}
            </Popup>
          )}
        </Marker>
      </MapContainer>
    </Box>
  );
};

export default LocationMap;
